import React, { Component } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getHourlyConditions as getHourlyConditionsByFieldId,
  getHourlyConditionsByLocation,
} from '../actions/weatherForecastActions';
import { HourlyForecast } from '../components/HourlyForecast';
import { FieldType, WeatherConditionsType } from '../types';

class HourlyForecastContainer extends Component {
  // TODO: Fix; will be called everytime remounted
  UNSAFE_componentWillMount() {
    const { getHourlyConditions: getHourlyConditionsProp, field } = this.props;

    getHourlyConditionsProp(field);
  }

  componentDidUpdate(prevProps) {
    const { getHourlyConditions: getHourlyConditionsProp, field } = this.props;

    if (prevProps.field.id !== field.id) {
      getHourlyConditionsProp(field);
    }
  }

  render() {
    const { hourlyConditions } = this.props;
    return (
      <div>
        {hourlyConditions.firstForecastTime ? (
          <HourlyForecast hourlyConditions={hourlyConditions} />
        ) : null}
      </div>
    );
  }
}

HourlyForecastContainer.propTypes = {
  field: FieldType,
  getHourlyConditions: func.isRequired,
  hourlyConditions: WeatherConditionsType,
};

function mapStateToProps(state) {
  return {
    field: state.field,
    hourlyConditions: state.weatherForecast.hourlyConditions,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { isMicrosoftWxFeatureAvailable } = ownProps;
  const getHourlyConditions = isMicrosoftWxFeatureAvailable
    ? getHourlyConditionsByLocation
    : getHourlyConditionsByFieldId;

  return bindActionCreators(
    {
      getHourlyConditions,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HourlyForecastContainer);
